import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerCode } from '../../models/logger';
import { LoggerService } from '../logger/logger.service';
import localParsedData from '../../../assets/content.json';
import localParseAEMdData from '../../../assets/aem-content.json';
import { GatekeeperService } from '../gate-keeper/gatekeeper.service';

@Injectable({
  providedIn: 'root',
})
export class ContentAsAService {
  contentPayload = new BehaviorSubject<any>('');

  constructor(
    private loggerService: LoggerService,
    private readonly gatekeeperService: GatekeeperService
  ) {
    this.loadContentPayload();
  }

  getContentPayload(): Observable<any> {
    return this.contentPayload.asObservable();
  }

  loadContentPayload() {
    this.gatekeeperService.getEnableAEMGatekeeper().subscribe((isEnableAEMGatekeeper) => {
      if (isEnableAEMGatekeeper) {
        this.loadContentFromAEMJson();
      } else {
        this.loadFromContentJson();
      }
    })
  }

  private loadContentFromAEMJson() {
    try {
      const response = require('../../../assets/aem-content.json')
      this.contentPayload.next(response.content.Data.Pw1Chunk.content);
    } catch (error) {
      this.loggerService.error(
        {
          message: error.message,
          status: error.status,
        },
        LoggerCode.AEM_CONTENT_NOT_LOADED,
      );
      this.contentPayload.next(localParseAEMdData.content.Data.Pw1Chunk.content);
    }
  }

  private loadFromContentJson() {
    try {
      const response = require('../../../assets/content.json')
      this.contentPayload.next(response.content.Data.Pw1Chunk.content);
    } catch (error) {
      this.loggerService.error(
        {
          message: error.message,
          status: error.status,
        },
        LoggerCode.AEM_CONTENT_NOT_LOADED,
      );
      this.contentPayload.next(localParsedData.content.Data.Pw1Chunk.content);
    }
  }
}
